import React from 'react';

interface CourseCardProps {
  image: string;
  title: string;
  description: string;
  date: string;
  duration: string;
  tags: string[];
}

const CourseCard: React.FC<CourseCardProps> = ({ image, title, description, date, duration, tags }) => {
  return (
    <div className="flex bg-white p-4 rounded-lg shadow-md mb-4">
      <img src={image} alt={title} className="w-20 h-20 rounded-lg mr-4" />
      <div className="flex flex-col justify-between">
        <div>
          <h3 className="text-lg font-semibold">{title}</h3>
          <p className="text-sm text-gray-600">{description}</p>
          <div className="flex gap-2 mt-2">
            {tags.map((tag, index) => (
              <span key={index} className="bg-purple-200 text-purple-700 px-2 py-1 rounded-full text-xs">
                {tag}
              </span>
            ))}
          </div>
        </div>
        <div className="flex justify-between items-center text-sm text-gray-500">
          <span>{date}</span>
          <span>{duration}</span>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
